import { render, staticRenderFns } from "./DashboradSearchCard.vue?vue&type=template&id=0ca7634c"
import script from "./DashboradSearchCard.vue?vue&type=script&lang=js"
export * from "./DashboradSearchCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports